import { action, observable } from 'mobx';
import moment from 'moment';

import customFetch from '../../../utils/customFetch';
import * as api from '../../../stores/api';

class FileReviewStore {
  @observable loading = true;
  @observable loadingClaimant = true;
  @observable loadingStaff = true;
  @observable loadingStaffAssignAction = true;
  @observable loadingStaffAssign = true;
  @observable loadingDynamicFRStatus = true;
  @observable loadingDynamicOverDueFRStatus = true;

  @observable data = null;
  @observable dataClaimant = null;
  @observable dataStaff = null;
  @observable dataStaffAssignAction = null;
  @observable dataStaffAssign = null;
  @observable dataDynamicFileReviewStatus = null;
  @observable dataDynamicOverDueFileReviewStatus = null;
  @observable dataPrepayment = null;
  @observable showBookingToday = false;

  @observable keyword = '';
  @observable keywordClaimant = ``;
  @observable numberSearch = 30;

  @observable sortKey = api.isCaseManager() ? 'RequestDate' : 'StatusDate';
  @observable sortColumn = 'Status Date';
  @observable sortDirection = 'descending';
  @observable filter = `All`;
  @observable searchClaimantOnly = false;
  @observable filterOverdue = `All`;
  @observable actionRequiredById = '';
  @observable fromTo = ``;
  @observable NextTaskPIC = null;
  @observable claimant = { Id: ``, FullName: `` };
  @observable PrepaymentType = 0;

  @observable curPage = 1;
  @observable totalPage = 0;
  @observable totalItems = 0;

  @observable open = false;
  @observable modalParams = {};

  @observable bodyForm = null;

  @observable assignStaffs = [];

  //Modal Supp request
  @observable loadingSuppRequest = true;
  @observable dataSuppRequest = null;
  @observable totalSuppRequest = 0;

  @action fetchSuppRequest = caseId => {
    this.loadingSuppRequest = true;
    customFetch(`/FileReview/GetSuppRequests?caseId=${caseId}&type=FR`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    }).then(
      action(data => {
        this.totalSuppRequest = data.itemList.length;
        this.dataSuppRequest = data;
        this.loadingSuppRequest = false;
      }),
    );
  };
  //

  @action setFieldsValue = data => {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
  };

  @action handleSort = ({ sortKey }, { column, direction }) => {
    this.sortColumn = column;
    this.sortDirection = direction;
    this.sortKey = sortKey;
    this.fetchFiles();
  };

  @action fetchClaimant = () => {
    this.loadingClaimant = true;
    customFetch('/FileReview/GetSuggestClaimant', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        keyword: this.keywordClaimant,
        Showing: 'active',
        numItemPerPage: this.numberSearch,
        IsSelectionList: true,
        curPage: 1,
      }),
    }).then(
      action(data => {
        this.dataClaimant = data;
        this.loadingClaimant = false;
      }),
    );
  };

  @action fetchPrepayment = () => {
    this.loadingPrepayment = true;
    customFetch('/FileReview/GetDynamicAssessmentPrepayment', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(),
    }).then(
      action(data => {
        this.dataPrepayment = data;
      }),
    );
  };

  @action fetchStaff = () => {
    this.loadingStaff = true;
    customFetch('/FileReview/GetStaffs', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(),
    }).then(
      action(data => {
        this.dataStaff = data;
        this.loadingStaff = false;
      }),
    );
  };
  @action fetchStaffAssignAction = () => {
    this.loadingStaffAssignAction = true;
    customFetch('/FileReview/GetStaffsAssignedActionRequired', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(),
    }).then(
      action(data => {
        // Action Required
        this.dataStaffAssignAction = data;
        this.loadingStaffAssignAction = false;
      }),
    );
  };
  @action fetchStaffAssign = () => {
    this.loadingStaffAssign = true;
    customFetch('/FileReview/GetStaffsAssign', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(),
    }).then(
      action(data => {
        // NextTaskPIC
        this.dataStaffAssign = data;
        this.loadingStaffAssign = false;
      }),
    );
  };
  @action fetchDynamicFileReviewStatus = () => {
    this.loadingDynamicFRStatus = true;
    customFetch('/FileReview/GetDynamicFileReviewStatus', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(),
    }).then(
      action(data => {
        // CaseStatus
        this.dataDynamicFileReviewStatus = data;
        this.loadingDynamicFRStatus = false;
      }),
    );
  };
  @action fetchDynamicOverDueFileReviewStatus = () => {
    this.loadingDynamicOverDueFRStatus = true;
    customFetch('/FileReview/GetDynamicOverDueFileReviewStatus', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(),
    }).then(
      action(data => {
        // Over Due
        this.dataDynamicOverDueFileReviewStatus = data;
        this.loadingDynamicOverDueFRStatus = false;
      }),
    );
  };

  getDateRange = () => {
    const [fromDate, toDate] = this.fromTo.split(' - ');
    return {
      fromDate: fromDate ? moment(fromDate, 'DD/MM/YYYY') : '',
      toDate: toDate ? moment(toDate, 'DD/MM/YYYY').toISOString() : '',
    };
  };

  @action fetchFiles = (setTotalPage = false) => {
    this.loading = true;
    const { fromDate, toDate } = this.getDateRange();

    let from = '';
    if (fromDate) {
      from = this.showBookingToday ? fromDate.format() : fromDate.toISOString();
    }

    const body = JSON.stringify({
      ActionRequired: false,
      ActionRequiredById: this.actionRequiredById,
      ActionType: 'NONE',
      From: from,
      To: toDate,
      CurPage: this.curPage,
      FilterOverdue: this.filterOverdue,
      FilterType: this.filter,
      ClaimantId: this.claimant.Id,
      Keyword: this.keyword,
      NextPicId: this.NextTaskPIC,
      NumItemPerPage: 20,
      Claimant: this.claimant,
      SearchClaimantOnly: this.searchClaimantOnly,
      SortBy: this.sortKey,
      SortDirection: this.sortDirection.replace('ending', '').toUpperCase(),
      UrgentReport: false,
      FilterPrepayment: this.PrepaymentType,
    });

    customFetch('/FileReview/FileReview_LoadList', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
    }).then(
      action(data => {
        this.data = data;
        this.bodyForm = body;
        if (data.curPage <= 1) {
          this.totalPage = data.sumPage;
          this.totalItems = data.sumItem;
        }
        this.fetchClaimant();
        this.fetchDynamicFileReviewStatus();
        this.fetchStaff();
        this.fetchDynamicOverDueFileReviewStatus();
        this.fetchStaffAssign();
        this.fetchStaffAssignAction();
        this.fetchPrepayment();
        this.loading = false;
      }),
    );
  };

  @action getData = () => {
    this.loading = true;
  };

  @action toggleModal2 = (isOpen, params = {}) => {
    this.open = isOpen;
    this.modalParams = params;
  };

  toggleModal = (isOpen, params = {}) => {
    return action(() => {
      this.open = isOpen;
      this.modalParams = params;
    });
  };

  @action refetch = (data = {}, setTotalPage = false) => {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
    this.fetchFiles(setTotalPage);
  };

  @action refetchClaimant = (data = {}, setTotalPage = false) => {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
    this.fetchClaimant(setTotalPage);
  };

  @action resetStore = () => {
    this.keyword = '';
    this.filter = 'All';
    this.sortColumn = 'Status Date';
    this.sortKey = api.isCaseManager() ? 'RequestDate' : 'StatusDate';
    this.sortDirection = 'descending';
    this.searchClaimantOnly = false;
    this.claimant = { Id: ``, FullName: `` };
    this.fromTo = ``;
    this.NextTaskPIC = null;
    this.actionRequiredById = ``;
    this.filterOverdue = `All`;
    this.showBookingToday = false;
    this.PrepaymentType = 0;

    this.curPage = 1;
    this.totalPage = 0;

    this.fetchFiles(true);
  };
  @action resetSearch = () => {
    this.keywordClaimant = '';
    this.numberSearch = 30;

    this.refetchClaimant();
  };
}

export default new FileReviewStore();
